import { IconButtonLink } from '@app/components/base/IconButtonLink';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import {
  buildSchedulesListOrderFilterUrl,
  SchedulesListCategory,
} from './build-schedules-list-order-filter-url';

const filterByOrderMessage = defineMessage({
  id: 'audit.confirmedBySchedule.filterByOrder',
  defaultMessage: 'Ver schedules de la orden {order}',
});

type Props = {
  order: string;
  scheduleDatetime: string;
  category: SchedulesListCategory;
};

/**
 * Icon button that opens the schedules list filtered by the given order
 * over a 30-day range centered on the schedule datetime.
 */
export function ConfirmedByScheduleOrderFilterButton({ order, scheduleDatetime, category }: Props) {
  const { $t } = useIntl();
  const station = useActiveStation();
  const timezone = useTimezone();

  const to = buildSchedulesListOrderFilterUrl({
    stationSlug: station.slug,
    category,
    order,
    scheduleDatetime,
    timezone,
  });

  return (
    <Tooltip title={$t(filterByOrderMessage, { order })}>
      <IconButtonLink to={to} size="small" color="primary" sx={{ p: 0.25 }}>
        <FilterAltOutlinedIcon fontSize="small" />
      </IconButtonLink>
    </Tooltip>
  );
}
